var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4139 110.653C89.0323 110.761 109.888 90.0811 109.996 64.4626C110.104 38.8442 89.4237 17.9887 63.8053 17.8807C38.1869 17.7726 17.3315 38.4528 17.2234 64.0713C17.1153 89.6897 37.7955 110.545 63.4139 110.653Z",
    stroke: "#121212",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.996 64.4373C103.902 86.7421 85.7439 104.747 63.4392 104.653C41.1345 104.559 23.1292 86.4013 23.2233 64.0966C23.3174 41.7918 41.4753 23.7865 63.78 23.8806C86.0847 23.9747 104.09 42.1326 103.996 64.4373Z",
    stroke: "#121212",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.5003,
    cy: 9.50708,
    rx: 6.59794,
    ry: 9.23714,
    transform: "rotate(0.241716 64.5003 9.50708)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.0384,
    cy: 119.032,
    rx: 6.59794,
    ry: 9.23714,
    transform: "rotate(0.241716 64.0384 119.032)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5073,
    cy: 64.0385,
    rx: 6.59795,
    ry: 9.23711,
    transform: "rotate(-89.7583 9.5073 64.0385)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.032,
    cy: 64.5004,
    rx: 6.59795,
    ry: 9.23711,
    transform: "rotate(-89.7583 119.032 64.5004)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.704117 0.710084 -0.710083 0.704118 105.069 14.521)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.704117 0.710084 -0.710083 0.704118 27.2966 91.6396)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59794,
    cy: 9.23713,
    rx: 6.59794,
    ry: 9.23713,
    transform: "matrix(0.925485 -0.378783 0.378782 0.925486 33.9209 7.53784)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59794,
    cy: 9.23713,
    rx: 6.59794,
    ry: 9.23713,
    transform: "matrix(0.925485 -0.378783 0.378782 0.925486 75.4072 108.903)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.386577 -0.922257 0.922257 0.386578 2.69434 45.6135)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.386577 -0.922257 0.922257 0.386578 103.705 87.9536)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.378782 0.925486 -0.925485 0.378783 121.001 33.9211)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.378782 0.925486 -0.925485 0.378783 19.637 75.4077)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59794,
    cy: 9.23713,
    rx: 6.59794,
    ry: 9.23713,
    transform: "matrix(0.922257 0.386578 -0.386577 0.922257 82.9253 2.69434)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59794,
    cy: 9.23713,
    rx: 6.59794,
    ry: 9.23713,
    transform: "matrix(0.922257 0.386578 -0.386577 0.922257 40.585 103.705)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.710083 -0.704118 0.704117 0.710084 14.5208 23.4697)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59795,
    cy: 9.23712,
    rx: 6.59795,
    ry: 9.23712,
    transform: "matrix(0.710083 -0.704118 0.704117 0.710084 91.6401 101.242)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7408 65.0074C82.6977 75.2104 74.3918 83.4466 64.1888 83.4036C53.9858 83.3605 45.7496 75.0545 45.7927 64.8515C45.8357 54.6486 54.1417 46.4123 64.3447 46.4554C74.5476 46.4984 82.7838 54.8044 82.7408 65.0074ZM62.0886 74.7024L75.853 61.0536C76.3204 60.5901 76.3235 59.8354 75.8601 59.3681L74.1817 57.6754C73.7182 57.2079 72.9635 57.2048 72.496 57.6683L61.2707 68.7993L56.0738 63.5584C55.6104 63.091 54.8557 63.0879 54.3882 63.5513L52.6956 65.2297C52.2282 65.6932 52.225 66.4479 52.6885 66.9153L60.403 74.6952C60.8665 75.1626 61.6211 75.1658 62.0886 74.7024Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -3.5,
    x2: 33.7869,
    y2: -3.5,
    transform: "matrix(-0.50903 -0.860749 0.871146 -0.491024 60.3765 52.082)",
    stroke: "#121212",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: 64.5002,
    x2: 109,
    y2: 64.5002,
    stroke: "#121212",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    y1: -3.5,
    x2: 33.7869,
    y2: -3.5,
    transform: "matrix(-0.50903 0.860749 -0.871146 -0.491024 56.1987 73.3076)",
    stroke: "#121212",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.85eeb44ca25bcb641c2629f0a2ee696c.svg";
export { ForwardRef as ReactComponent };